import { Flex, Text, CloseIcon, IconButton } from 'vvs-uikit'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { useTranslation } from 'contexts/Localization'

import { GachaponOption } from '../types'

import { GachaponModalFlex, ModalCloseButton, GachaponSelectionButton } from './styles'

const GachaponSelection: React.FC<{
  onDismiss: () => any
  onSelect: (selection: GachaponOption) => any
}> = ({ onDismiss, onSelect }) => {
  const { t } = useTranslation()

  return (
    <GachaponModalFlex grassBg>
      <ModalCloseButton>
        <IconButton variant="text" onClick={onDismiss}>
          <CloseIcon fill="black" />
        </IconButton>
      </ModalCloseButton>
      <Flex flexDirection="column" alignItems="center" mt={4}>
        <Text color="black" fontSize="20px" fontWeight="600" mt={2}>
          {t('Select your lucky draw category')}
        </Text>
        <Text color="black" fontSize="13px" fontWeight="700">
          {t('Stand to win as much as 10 EXP or HP each round!')}
        </Text>
        <Flex mx={3} mt={4} mb={5} gap="6px">
          <GachaponSelectionButton onClick={() => onSelect('exp')}>
            <PixelatedImage src="/images/vvsGotchi/gachapon-machine-xp.png" />
          </GachaponSelectionButton>
          <GachaponSelectionButton onClick={() => onSelect('hp')}>
            <PixelatedImage src="/images/vvsGotchi/gachapon-machine-hp.png" />
          </GachaponSelectionButton>
        </Flex>
      </Flex>
    </GachaponModalFlex>
  )
}

export default GachaponSelection
